import initEconomicCalendar from '../economic_calendar';

document.addEventListener('DOMContentLoaded', (e) => {
  initEconomicCalendar();
});
